export default __webpack_public_path__ + "static/media/signin_background.bc8d8b89.svg";